import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  root: {
    position: 'relative',
    width: '100%',
    height: 'auto',
    marginBottom: '1.5rem',
    marginTop: '1.5rem',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.25rem',

    '& span': {
      fontFamily: 'Sora',
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '160%',
    },
  },

  logo: {
    height: '1.375rem',
  },
})

const FooterLogo = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <span>Powered By</span>
      <img
        className={classes.logo}
        src={'/default/logo.svg'}
        alt='powered logo'
      />
    </div>
  )
}

export default FooterLogo
